import styled from 'styled-components'
import { Title } from '@usap/widgets'
import {
  Box,
  IcoMoon,
} from '@usap/uicomponents'

export const Container = styled(Box)`
  margin: 0px auto;
  padding: ${props => props.theme.global.edgeSize.medium} ${props => props.theme.global.edgeSize.small};
`

export const SummaryTitle = styled(Title)`
  text-transform: capitalized;
  font-size:  ${props => props.theme.global.text.small.size}px;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    font-size:  ${props => props.theme.global.text.medium.size}px;
  }
`

export const Content = styled.span`
  font-size: 16px;
  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;  
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 1em;

  & * {
    margin: 0;
  }
  
  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    -webkit-line-clamp: 2;
    line-clamp: 2;
  }
`

export const ToggleInput = styled.input`
  opacity: 0;
  display: none;
  pointer-events: none;

  &:focus ~ label {
    outline: -webkit-focus-ring-color auto 5px;
  }
  
  &:checked + #${props => props.contentKey} {
    -webkit-line-clamp: unset;
  }
`

export const ToggleArrow = styled(IcoMoon)`
  cursor: pointer;
  margin-bottom: -4px;
`

export const ToggleText = styled.label`
  cursor: pointer;
  font-size: 16px;
  color: ${props => props.theme.global.colors.blueLink};
  line-height: normal;
  margin-top: 0.5em;
`

export default {
  SummaryTitle,
  Container,
  Content,
  ToggleArrow,
  ToggleInput,
  ToggleText,
}
